<script setup lang="ts">
import VButton from '@components/buttons/VButton/VButton.vue';
import VDialog from '@components/dialogs/VDialog/VDialog.vue';
import { useAffiliatesTranslate } from '@modules/affiliates-approved/composables';
import {
  ManagerField,
} from '@modules/affiliates-approved/types';
import VForm from '@modules/forms/components/VForm/VForm.vue';

import type { IChangeManagerDialogEmits, IChangeManagerDialogProps } from './types';
import { useChangeManager } from './composables';

const props = withDefaults(defineProps<IChangeManagerDialogProps>(), {
  selectedAffiliates: () => [],
});

const emit = defineEmits<IChangeManagerDialogEmits>();

const visible = defineModel<boolean>('visible');

const { translate } = useAffiliatesTranslate();
const {
  formValues,
  isChangingManagerLoading,
  errors,
  formSchema,
  clearError,
  handleChange,
  confirmChanging,
  handleShowDialog,
  resetFormValues,
} = useChangeManager(props, visible, emit);
</script>

<template>
  <VDialog
    v-model:visible="visible"
    :title="translate('CHOOSE_MANAGER_TITLE')"
    @show="handleShowDialog"
    @hide="resetFormValues"
  >
    <template #default>
      <VForm
        :schema="formSchema"
        :is-loading="isChangingManagerLoading"
        :custom-errors="errors"
        @change="handleChange"
        @interacted="clearError"
      />
    </template>
    <template #footer>
      <VButton
        :label="translate('CHOOSE_MANAGER_OK')"
        :disabled="!formValues?.[ManagerField]"
        :loading="isChangingManagerLoading"
        @click="confirmChanging($event)"
      />
    </template>
  </VDialog>
</template>
